var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGatepass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.44444C1 2.98985 2.98985 1 5.44444 1H16.5556C19.0102 1 21 2.98985 21 5.44444C21 5.98773 20.6884 6.48288 20.1986 6.71798L19.7113 6.95192C17.993 7.7767 17.993 10.2233 19.7113 11.0481L20.1986 11.282C20.6884 11.5171 21 12.0123 21 12.5556C21 15.0102 19.0102 17 16.5556 17H5.44444C2.98985 17 1 15.0102 1 12.5556C1 12.0123 1.31157 11.5171 1.80135 11.282L2.28872 11.0481C4.00702 10.2233 4.00702 7.7767 2.28872 6.95192L1.80135 6.71798C1.31157 6.48288 1 5.98773 1 5.44444Z",
    stroke: "#919DA9",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0175 6.73737C10.3268 5.75421 11.6732 5.75421 11.9825 6.73737C12.1208 7.17705 12.5174 7.47473 12.965 7.47473C13.9657 7.47473 14.3818 8.79756 13.5722 9.40519C13.2101 9.67693 13.0586 10.1586 13.1969 10.5983C13.5062 11.5814 12.4168 12.399 11.6072 11.7914C11.2451 11.5196 10.7549 11.5196 10.3928 11.7914C9.58318 12.399 8.49385 11.5814 8.80309 10.5983C8.94139 10.1586 8.78989 9.67693 8.42782 9.40519C7.6182 8.79756 8.03429 7.47473 9.03503 7.47473C9.48257 7.47473 9.87921 7.17705 10.0175 6.73737Z",
    stroke: "#919DA9",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatepass);
export default __webpack_public_path__ + "static/media/gatepass.65150fe29cf14103dbfbac25d256dae3.svg";
export { ForwardRef as ReactComponent };